// selectors.js
export const selectSingleMatterData = (state) => state.singleMatter.data;
export const selectSingleMatterLoading = (state) => state.singleMatter.loading;
export const selectSingleMatterError = (state) => state.singleMatter.error;
export const selectSingleMatterReset = (state) => state.singleMatter.error;
